import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import * as wtconfig from "./config/wt.config";


// 获取租户配置
const getConfig = async () => {

  const response = await fetch('')

  const env = response.headers.get('x-webtrader-env');
  const tenantId = response.headers.get('x-webtrader-tenant-id');

  // local环境无指定头，租户配置使用本地数据
  if (!env || !tenantId) return

  localStorage.setItem('env', env);
  localStorage.setItem('tenantId', tenantId);

  const baseUrl = `${wtconfig.WT_CONFIG.ASSETS_URL}/${env}/${tenantId}`;

  const link = document.querySelector('#favicon');
  link.setAttribute('href', `${baseUrl}/assets/images/favicon.ico`);

  const config = (await fetch(`${baseUrl}/config/wt.config.json`).then((res) => res.json()))

  Object.assign(wtconfig.WT_CONFIG, config, { ASSETS_URL: baseUrl })
}

(async () => {
  await getConfig();

  // TODO: environment.production配置无效 build后仍 ===false
  if (environment.production) {
    // Google Analytics Code Snippet
    if (
      wtconfig.WT_CONFIG.GA_TRACKING_CODE &&
      wtconfig.WT_CONFIG.GA_TRACKING_CODE !== ""
    ) {
      const script1 = document.createElement("script");

      script1.src = `https://www.googletagmanager.com/gtag/js?id=${wtconfig.WT_CONFIG.GA_TRACKING_CODE}`;
      document.head.appendChild(script1);

      const script2 = document.createElement("script");
      script2.innerHTML = ` window.dataLayer = window.dataLayer || [];

    function gtag() {
        dataLayer.push(arguments);
    }
    gtag('js', new Date());

    gtag('config','${wtconfig.WT_CONFIG.GA_TRACKING_CODE}');`;

      document.head.appendChild(script2);
    }
    if (
      wtconfig.WT_CONFIG.LOGGING_BASE_URL &&
      wtconfig.WT_CONFIG.LOGGING_BASE_URL !== ""
    ) {
      const script3 = document.createElement("script");
      script3.innerHTML = `
    window.onerror = function (errorMsg, url, lineNumber) {
      var req = new XMLHttpRequest();
      var params = 'error= ' + errorMsg.message ;
      req.open('POST', '${wtconfig.WT_CONFIG.LOGGING_BASE_URL}/logError');
      req.setRequestHeader('Content-type', 'application/json;charset=UTF-8');
      req.setRequestHeader('secretkey', '${wtconfig.WT_CONFIG.SECRET_KEY}');
      req.send(JSON.stringify({ error: errorMsg.message }));
    }`;

      document.head.appendChild(script3);
    }
    enableProdMode();
  }

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
})()



